import {
  to
} from "./anacapri-chunk.5OKHRCVN.js";
import {
  Icon
} from "./anacapri-chunk.UJIMJHJN.js";
import {
  Rt
} from "./anacapri-chunk.5KELFBS4.js";
import {
  base_default,
  e,
  n,
  r,
  token_default
} from "./anacapri-chunk.3P6V43X6.js";
import {
  AnacapriElement
} from "./anacapri-chunk.3HZGRT44.js";
import {
  customElement_default
} from "./anacapri-chunk.YC5RXRZP.js";
import {
  i
} from "./anacapri-chunk.TOMZZDRF.js";
import {
  er,
  ke
} from "./anacapri-chunk.7OQQIROZ.js";
import {
  D
} from "./anacapri-chunk.37PM4VTN.js";
import {
  __decorateClass
} from "./anacapri-chunk.AHXTNXK6.js";

// src/components/button/button.css
var styles = i`/** HOST DEFAULTS

    We set all of the button specific variables on the host element for
    two reasons:
    1. They are easier to override from the outside if need be.
    2. The button group margin collapse styles rely on the
        '--ana-button-border-width' being defined on the host
        to know how much it needs to nudge the button by.
  */

:host {
  --ana-button-default-border-radius: var(--ao-border-radius-l);
  --ana-button-default-justify: center;

  --ana-button-padding: 0 var(--ao-space-m);
  --ana-button-border-width: 2px;
  --ana-button-border-color: transparent;
  --ana-button-background-color: transparent;
  --ana-button-font-weight: bold;
  --ana-color: var(--ao-color-steel);

  display: inline-block;
  height: var(--ao-height-m);
}

/** HOST VARIANT OVERRIDES

    The default when no variant is treated as 'variant="primary"'.
  */
:host(:not([variant])),
:host([variant='primary']) {
  --ana-color: white;
  --ana-button-background-color: var(--ao-color-steel);
  --ana-button-border-width: 0;
}

:host([variant='secondary']) {
  --ana-color: var(--ao-color-blue);
  --ana-button-border-color: var(--ao-color-steel);
}

:host([variant='link']) {
  --ana-button-default-border-radius: var(--ao-border-radius-s);
  --ana-button-border-width: 0;
  --ana-button-font-weight: normal;
  height: auto;
}

:host([variant='context-menu']) {
  --ana-button-default-justify: flex-start;
  --ana-button-default-border-radius: 6px;
  --ana-button-padding: 0 1rem;
  --ana-button-background-color: white;
  --ana-button-border-color: var(--ao-color-steel);
  --ana-button-border-width: 0px;
  --ana-color: var(--ao-color-steel);
  text-decoration: none;
  line-height: 3rem;
  text-align: left;
  width: 100%;
  text-wrap: nowrap;
}

:host([variant='form']) {
  --ana-color: var(--ao-color-blue);
  --ana-button-background-color: var(--ao-color-sky-light);
  --ana-button-border-color: var(--ao-color-blue);
  --ana-button-border-width: 1px;

  height: var(--ao-height-xs);
}

:host([variant='prefiller']) {
  --ana-button-default-border-radius: var(--ao-border-radius-m);
  --ana-button-default-justify: flex-start;

  --ana-button-padding: 1rem;
  --ana-button-background-color: white;
  --ana-button-border-color: var(--ao-color-attention-dark);
  --ana-button-border-width: 1px;

  min-height: var(--ao-height-m);
  height: auto;
}

:host([variant='tile']) {
  --ana-button-default-border-radius: var(--ao-border-radius-s);
  --ana-button-default-justify: flex-start;

  --ana-button-padding: 1rem;
  --ana-color: undefined;
  --ana-button-background-color: white;
  --ana-button-border-color: var(--ao-color-attention-dark);
  --ana-button-border-width: 1px;

  min-height: var(--ao-height-m);
  height: auto;
}

:host([variant='close']) {
  --ana-button-default-border-radius: var(--ao-border-radius-s);

  --ana-color: var(--ao-color-attention);
  --ana-button-background-color: transparent;
  --ana-button-border-width: 0;

  height: var(--ao-height-xs);
}

/** BASE BUTTON */

.button {
  display: inline-flex;
  align-items: center;
  justify-content: var(--ana-button-justify, var(--ana-button-default-justify));
  gap: 0 0.5rem;

  box-sizing: border-box;
  appearance: none;
  cursor: pointer;

  font-family: var(--ao-font-heading);
  font-size: 1rem;
  font-weight: var(--ana-button-font-weight);
  color: var(--ana-color);

  margin: 0;
  padding: var(--ana-button-padding);

  background-color: var(--ana-button-background-color);
  border: var(--ana-button-border-width) solid var(--ana-button-border-color);
  border-radius: var(--ana-button-border-radius, var(--ana-button-default-border-radius));
  outline: 0;
  height: 100%;
  width: 100%;

  text-decoration: none;
  text-align: left;

  transition: var(--ana-transition-focus);

  z-index: var(--ao-z-index-button);
}

/** BUTTON VARIANT OVERRIDES */

.button.tertiary {
  text-decoration: underline;
}

.button.link {
  padding: 0;
  text-decoration: underline;
}

.button.prefiller {
  border: var(--ana-button-border-width) dashed var(--ana-button-border-color);

  font-weight: normal;
  font-style: italic;

  /** Set the prefiller behind other buttons, other borders should take
        precedence when grouped together. */
  z-index: var(--ao-z-index-button-prefiller);
}

.button.form {
  font-weight: normal;
}

.button.tile {
  border-top: 8px solid var(--ana-button-border-color);
  font-weight: normal;
}

:host(.nested-tile) .button.tile {
  border-top: var(--ana-button-border-width, 1px) solid var(--ana-button-border-color);
}

.button.close {
  height: 2rem;
  width: 2rem;
}

.button.close:before {
  font-size: 1.33333em;
  content: '\\f00d';
  font-family: 'FontAwesome';
  display: flex;
  align-items: center;
  justify-content: center;
}

.button.context-menu {
  font-weight: normal;
}

/** button provides a hover style, we need to override this
  * because we are relying on focus for styling now to avoid having two
  * items with 'focus/hover' styling.
  */
.button.context-menu:hover {
  --ana-color: var(--ao-color-steel);
  --ana-button-background-color: var(--ao-color-white);
}
/** context-menu focus must be defined after hover so it overrides hover
  * also for some reason cant use variable properties for focus here
  */
.button.context-menu:focus {
  background-color: var(--ao-color-sky-light);
  color: var(--ao-color-steel-dark);
}

/** FEEDBACK STATES

    Currently the only variants to respond to feedback states
    are the primary button, prefiller, and tile flavor.
  */

.warning.button.primary {
  --ana-color: var(--ao-color-white);
  --ana-button-background-color: var(--ao-color-orange);
  --ana-button-border-color: var(--ao-color-orange);
}

.warning.button.primary:focus-visible,
.warning.button.primary:hover {
  --ana-color: var(--ao-color-orange);
  --ana-button-background-color: var(--ao-color-white);
}

.error.button.form {
  --ana-color: var(--ao-color-red);
  --ana-button-border-color: var(--ao-color-red);
  --ana-button-background-color: var(--ao-color-red-faded);
}

.error.button.form:hover {
  --ana-color: var(--ao-color-red);
  --ana-button-background-color: var(--ao-color-white);
}

.warning.button:is(.prefiller) {
  --ana-color: var(--ao-color-steel-dark);
}

.warning.button:is(.tile, .prefiller) {
  --ana-button-border-color: var(--ao-color-orange);
  --ana-button-background-color: var(--ao-color-orange-faded);

  z-index: var(--ao-z-index-button-feedback);
}

.error.button:is(.prefiller) {
  --ana-color: var(--ao-color-steel-dark);
}

.error.button:is(.tile, .prefiller) {
  --ana-button-border-color: var(--ao-color-red);
  --ana-button-background-color: var(--ao-color-red-faded);

  z-index: var(--ao-z-index-button-feedback);
}

.warning.button:is(.tile, .prefiller):hover {
  --ana-button-background-color: white;
  --ana-button-border-color: var(--ao-color-orange);
}

.error.button:is(.tile, .prefiller):hover {
  --ana-button-background-color: white;
  --ana-button-border-color: var(--ao-color-red);
}

/** FOCUS STATES */

.button:not(.link):focus-visible {
  --ana-button-background-color: white;

  outline: 0;
  z-index: var(--ao-z-index-focus);
}

.button::before {
  content: '';
  display: inline-block;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: var(--ana-button-border-radius, var(--ana-button-default-border-radius));
  border: 2px solid transparent;
  transition: var(--ana-transition-focus);
}

.button:not(.link, .context-menu):focus-visible::before {
  border-color: var(--ao-color-attention);
  box-shadow: 0 0 0 4px var(--ao-color-blue);
}

.button:where(.prefiller, .tile)::before {
  border-radius: var(--ana-button-default-border-radius);
}

/** The thick top border on tile buttons require
      us to make some adjustments
      the the focus styles absolute positioning. */
.button.tile:focus-visible::before {
  box-sizing: content-box;
  top: -4px;
  left: -2px;
}

.button.primary:focus-visible {
  --ana-color: var(--ao-color-blue);
}

.button.link:focus-visible {
  box-shadow: 0 0 0 2px var(--ao-color-blue);
}

.button.close:focus-visible {
  --ana-color: var(--ao-color-blue);
}

/** HOVER STATES */

.button:not(.link, .context-menu):hover {
  --ana-color: var(--ao-color-blue);
  --ana-button-background-color: var(--ao-color-sky);
}

.button.primary:hover {
  --ana-color: var(--ao-color-attention);
  --ana-button-background-color: var(--ao-color-blue-dark);
}

.button.tertiary:hover {
  --ana-button-border-color: var(--ao-color-steel);
}

.button.prefiller:hover {
  --ana-color: var(--ao-color-steel-dark);
  --ana-button-background-color: var(--ao-color-sky-light);
}

.button.tile:hover {
  --ana-color: var(--ao-color-charcoal);
  --ana-button-background-color: var(--ao-color-sky-light);
}

.button.close:hover {
  --ana-color: var(--ao-color-blue);
  --ana-button-background-color: white;
}

/** DISABLED STATES */

/**
  * Additional specificity to take effect over warning
  * and error styles.
  */
.button.button.disabled {
  cursor: default;
  pointer-events: none;

  --ana-color: var(--ao-color-ash);
  --ana-button-background-color: var(--ao-color-fog);
  --ana-button-border-color: var(--ao-color-smoke);
}

.button.primary.disabled {
  --ana-color: var(--ao-color-fog);
  --ana-button-background-color: var(--ao-color-ash);
  --ana-button-border-color: transparent;
}

.button.link.disabled {
  --ana-button-background-color: transparent;
  --ana-button-border-color: transparent;
}

.button.prefiller.disabled,
.button.tile.disabled {
  --ana-button-background-color: transparent;
}

/** SUFFIX & PREFIX SLOTS

    We need to remove text decoration from
    button icons to insure they don't get underlines from
    text styling. Setting text-decoration: none doesn't
    work due to the display: contents set on slot. We
    instead hide the underline by changing the color
    to be transparent.
  */

.button slot[name='prefix'],
.button slot[name='suffix'] {
  text-decoration-color: transparent;
}

/** BUTTON GROUPS

    We add the button group classes that effect button styles
    to the button to get around some of the style encapsulation
    issues the shadow DOM can present.
  **/

:host(:not([variant='context-menu']).ana-button-group-button) {
  width: auto;
}

/**
  * This helps expand nested buttons in a group to fill the allotted
  * space.
  */
:host(.ana-button-group-button.ana-button-group-button-nested) {
  flex: 1 auto;
}

/**
    In button groups we need to make sure the borders of each button
    overlap to give the illusion of a shared border.
  */
:host(.ana-button-group-button.ana-button-group-button-horizontal.ana-button-group-shared-border) {
  margin-left: calc(-1 * var(--ana-button-border-width, 1px));
}

:host(.ana-button-group-button.ana-button-group-button-vertical.ana-button-group-shared-border) {
  margin-top: calc(-1 * var(--ana-button-border-width, 1px));
}
`;
var button_default = styles;

// src/components/button/button.ts
var Button = class extends AnacapriElement {
  constructor() {
    super();
    this.groupError = false;
    this.groupWarning = false;
    this.groupDisabled = false;
    this.disabled = false;
    this.error = false;
    this.warning = false;
    this.caret = false;
    this.type = "button";
    if (this.attachInternals) {
      this.internals = this.attachInternals();
    }
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener("click", this.handleClick);
  }
  static get formAssociated() {
    return true;
  }
  getVariant() {
    return this.variant ?? "primary";
  }
  isLink() {
    return this.href ? true : false;
  }
  /**
   * If a developer programmatically calls `click()` on the `ana-button`
   * element while disabled, the event could still be propagated. This
   * stops any click events from being emitted when the button is disabled.
   * @param event - the click event.
   */
  handleClick(event) {
    if (isDisabled(this)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (this.type === "submit") {
      this.internals?.form?.requestSubmit();
    }
  }
  handleFocus(event) {
    if (isDisabled(this)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  /**
   * Pass focus to the internal `<button>` element.
   */
  focus() {
    this.button?.focus();
  }
  connectedCallback() {
    super.connectedCallback();
    this.button?.addEventListener("click", this.handleClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.button?.removeEventListener("click", this.handleClick);
    this.removeEventListener("click", this.handleClick);
  }
  willUpdate(changedProperties) {
    if (changedProperties.has("height")) {
      this.style.setProperty("min-height", "auto");
      this.style.setProperty("height", `var(--ao-height-${this.height})`);
    }
    if (changedProperties.has("width")) {
      this.style.setProperty("width", `100%`);
      this.style.setProperty("max-width", `var(--ao-width-${this.width})`);
    }
    if (hasWarning(this) || hasError(this)) {
      this.style.setProperty("--ana-button-border-width", "2px");
    } else {
      this.style.removeProperty("--ana-button-border-width");
    }
  }
  /* eslint-disable lit/binding-positions, lit/no-invalid-html */
  render() {
    const isLink = this.isLink();
    const tag = isLink ? er`a` : er`button`;
    const variant = this.getVariant();
    const disabled = isDisabled(this);
    const error = hasError(this);
    const warning = hasWarning(this);
    return ke`
      <${tag}
      part="base${warning ? " warning" : ""}${error ? " error" : ""}"
      class=${Rt({
      button: true,
      [variant]: true,
      disabled,
      warning,
      error
    })}
      @focus=${this.handleFocus}
      type=${to(isLink ? void 0 : this.type)}
      ?disabled=${to(isLink ? void 0 : disabled)}
      aria-disabled=${disabled ? "true" : "false"}
      tabindex=${disabled ? "-1" : "0"}
      aria-label=${to(variant === "close" ? "Close" : void 0)}
      href=${to(this.href)}
      target=${to(isLink ? this.target : void 0)}>
        <slot part="prefix" name="prefix"></slot>
        <slot></slot>
        <slot part="suffix" name="suffix">
          ${this.caret ? ke`<${Icon.tag} size="18" name="caret"></${Icon.tag}>` : D}
        </slot>
      </${tag}>
    `;
  }
};
Button.styles = [base_default, token_default, button_default];
__decorateClass([
  e(".button")
], Button.prototype, "button", 2);
__decorateClass([
  r()
], Button.prototype, "groupError", 2);
__decorateClass([
  r()
], Button.prototype, "groupWarning", 2);
__decorateClass([
  r()
], Button.prototype, "groupDisabled", 2);
__decorateClass([
  n({ reflect: true })
], Button.prototype, "variant", 2);
__decorateClass([
  n()
], Button.prototype, "href", 2);
__decorateClass([
  n()
], Button.prototype, "target", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], Button.prototype, "disabled", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], Button.prototype, "error", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], Button.prototype, "warning", 2);
__decorateClass([
  n()
], Button.prototype, "width", 2);
__decorateClass([
  n()
], Button.prototype, "height", 2);
__decorateClass([
  n({ type: Boolean })
], Button.prototype, "caret", 2);
__decorateClass([
  n({ reflect: true })
], Button.prototype, "type", 2);
Button = __decorateClass([
  customElement_default("ana-button")
], Button);

// src/components/button/button.utilities.ts
function isDisabled(buttonFeedback) {
  return buttonFeedback.disabled || buttonFeedback.groupDisabled;
}
function canHaveFeedbackState(buttonFeedback) {
  return !isDisabled(buttonFeedback) && (buttonFeedback.variant === "prefiller" || buttonFeedback.variant === "tile" || buttonFeedback.variant === "form" || buttonFeedback.variant === "primary");
}
function hasError(buttonFeedback) {
  return canHaveFeedbackState(buttonFeedback) && (buttonFeedback.error || buttonFeedback.groupError);
}
function hasWarning(buttonFeedback) {
  return canHaveFeedbackState(buttonFeedback) && (buttonFeedback.warning || buttonFeedback.groupWarning);
}
function findButton(element) {
  return element.closest(Button.tagName) ?? element.querySelector(Button.tagName);
}

export {
  isDisabled,
  hasError,
  hasWarning,
  findButton,
  Button
};
